<template>
  <div class="readingPenDownload py-4 lg:py-6 xl:py-8 px-2 md:px-4">
    <div class="readingPenSearchBar">
      <div class="title my-5 lg:my-8 md:flex md:justify-center">
        <h1 class="text-center font-black text-lg md:text-xl text-NotoSansBold md:mr-2">LiveABC 智慧點讀筆</h1>
        <h1 class="text-center font-black text-lg md:text-xl text-NotoSansBold">音檔下載專區</h1>
      </div>
      <div class="searchList flex">
        <div class="text-gray-700 w-full mx-auto flex max-w-xl lg:max-w-2xl border border-gray-800 rounded-lg">
          <input type="text" name="serch" placeholder="請輸入欲搜尋關鍵字 如:多益 TOEIC..."
            v-model="searchValue" v-on:keyup.13="search"
            class="bg-white w-full  h-10 text-sm focus:outline-none mx-4 text-NotoSansRegular textColorDarkBlack">
          <a class="cursor-pointer items-center justify-center px-2 flex" @click="cleanSearch()"
          :class="{ closeHide: searchValue === null }" :disabled="searchValue === null" >
            <font-awesome-icon icon="times" class="text-sm textColorDarkBlack" />
          </a>
          <a class="cursor-pointer items-center justify-center pl-3 pr-4 flex" @click.prevent="search()">
            <font-awesome-icon icon="search" class="text-sm textColorDarkBlack text-gray-700" />
          </a>
        </div>
      </div>
      <nav class="flex mx-auto text-sm sm:mb-4 mt-1 justify-center flex-wrap py-2">
        <p class="no-underline text-blue-800 px-2 font-medium bg-indigo hover:bg-indigo-darker text-NotoSansBold" href="#">熱搜關鍵字</p>
        <a class="no-underline text-blue-800 font-medium bg-indigo text-NotoSansRegular cursor-pointer"
          v-for="(item, index) in searchList" :key="index" @click="setsearchValue(item.name)">
          <span class="mx-1 hover:bg-gray-100">{{ item.name }}</span>
          <span class="mx-1" :class="{ lastHint: searchList.lastIndexOf(item) == searchList.length - 1}">|</span>
        </a>
      </nav>
    </div>
    <div class="main">
      <div class="py-4 xl:py-8 lg:py-6 md:py-4">
        <div class="flex">
          <div class="w-full md:w-1/4 xl:pr-4 lg:pr-3 hidden md:block">
            <AccordionMenu />
          </div>
          <div class="w-full md:w-3/4 md:pl-8 lg:pl-4">
            <div class="w-full min-h-50" v-if="downloadList !== null">
              <div class="w-full" v-for="(item, index) in downloadList" :key="index">
                <Item :downloadData="downloadList[index]" />
              </div>
            </div>
            <div class="w-full loading" v-else>
              <div class="hidden lg:block">
                <vue-content-loading :width="300" :height="65" v-for="(item, index) in 10" :key="index">
                  <rect cx="30" cy="30" width="45" r="30" height="50" x="10" />
                  <rect cx="30" cy="80" r="50" x="70" y="0" rx="3" ry="3" width="180" height="8" />
                  <rect x="70" y="15" rx="3" ry="3" width="200" height="8" />
                  <rect x="70" y="35" r="10" ry="10" width="40" height="10" />
                  <rect x="120" y="35" r="10" ry="10" width="40" height="10" />
                  <rect x="170" y="35" r="10" ry="10" width="40" height="10" />
                  <rect x="220" y="35" r="10" ry="10" width="40" height="10" />
                </vue-content-loading>
              </div>
              <div class="hidden sm:block lg:hidden">
                <vue-content-loading :width="300" :height="180" v-for="(item, index) in 5" :key="index">
                  <rect cx="30" cy="30" width="50" r="30" height="50" x="10" />
                  <rect cx="30" cy="80" r="50" x="70" y="0" rx="3" ry="3" width="200" height="10" />
                  <rect x="70" y="15" rx="3" ry="3" width="200" height="10" />
                  <rect x="10" y="60" r="10" ry="10" width="260" height="20" />
                  <rect x="10" y="85" r="10" ry="10" width="260" height="20" />
                  <rect x="10" y="110" r="10" ry="10" width="260" height="20" />
                  <rect x="10" y="135" r="10" ry="10" width="260" height="20" />
                </vue-content-loading>
              </div>
              <div class="sm:hidden">
                <vue-content-loading :width="300" :height="400"  v-for="(item, index) in 3" :key="index">
                  <rect cx="30" cy="30" width="200" r="30" height="200" x="50" />
                  <rect cx="30" cy="80" r="50" x="20" y="210" rx="3" ry="3" width="200" height="10" />
                  <rect x="20" y="230" rx="3" ry="3" width="200" height="10" />
                  <rect x="10" y="250" r="10" ry="10" width="270" height="20" />
                  <rect x="10" y="280" r="10" ry="10" width="270" height="20" />
                  <rect x="10" y="310" r="10" ry="10" width="270" height="20" />
                  <rect x="10" y="340" r="10" ry="10" width="270" height="20" />
                </vue-content-loading>
              </div>
            </div>

              <PaginateComponent :pagination="pagination" v-on:pageChangeHandler="pageChangeHandler" />

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-expressions */
import axios from 'axios'
import PaginateComponent from '@/components/modules/Paginatation'
import AccordionMenu from '@/components/product/AccordionMenu'
import VueContentLoading from 'vue-content-loading'
import Item from '@/components/livepen/DownloadItem'
export default {
  name: 'downloadPage',
  metaInfo () {
    return {
      title: '下載專區'
    }
  },
  data () {
    return {
      // pagination
      pageNum: 5,
      pagination: {
        currentPage: 1,
        length: 1
      },

      searchValue: null,
      searchList: [
        { name: 'TOEIC' },
        { name: '托福' },
        { name: '雅思' },
        { name: '全民英檢' },
        { name: '日語' },
        { name: '圖解' },
        { name: '閱讀' },
        { name: '句型' }
      ],
      downloadList: null
    }
  },
  watch: {
    '$route.query.keyword': {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.pagination.currentPage = 1
          this.getData()
        }
      },
      deep: true
    },
    '$route.query': {
      handler (newVal, oldVal) {
        if ((newVal.category !== oldVal.category) || (newVal.type !== oldVal.type)) {
          this.getData()
        }
      }
    }
  },
  components: {
    AccordionMenu,
    PaginateComponent,
    VueContentLoading,
    Item
  },
  computed: {
  },
  mounted () {
    this.getData()
  },
  updated () {
  },
  methods: {
    async getData () {
      let self = this
      let dataObj = {
        params: {
          scope: 'download'
        }
      }
      if (self.$route.query.category) {
        dataObj.params.category = self.$route.query.category
      }

      if (self.$route.query.keyword) {
        dataObj.params.query = self.$route.query.keyword
      }

      if (self.$route.query.type) {
        dataObj.params.type = self.$route.query.type
      }

      if (self.$route.query.P) {
        self.pagination.currentPage = Number(self.$route.query.P)
      } else {
        self.pagination.currentPage = 1
      }

      let { data } = await axios.get(`/products?page=${self.pagination.currentPage}&pageSize=10`, dataObj)
      self.downloadList = data.data
      self.pagination.length = data.last_page
    },
    async pageChangeHandler (pageChangeHandler) {
      let self = this
      self.pagination.currentPage = pageChangeHandler

      let q = {}
      self.$route.query.category ? q.category = self.$route.query.category : null
      self.$route.query.keyword ? q.keyword = self.$route.query.keyword : null
      q.P = pageChangeHandler

      await self.$router.push({ name: 'download', query: q })

      self.getData()
    },
    cleanSearch () {
      this.searchValue = null
    },
    async search () {
      let self = this
      if (self.searchValue) {
        await self.$router.push({ name: 'download', query: { keyword: self.searchValue } })
        self.getData()
      }
    },
    async setsearchValue (item) {
      let self = this
      self.searchValue = item
      await self.$router.push({ name: 'download', query: { keyword: item } })
      self.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.closeHide {
  opacity: 0;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
}
.readingPenDownload {
  .readingPenSearchBar {
    .lastHint {
      display: none;
    }
  }
  .main {
    @media (max-width: 577px) {
      .cover {
        max-height: 80%;
        max-width: 80%;
      }
    }
  }
}
</style>
